import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceRemote extends PoolDevice implements PoolDeviceInterface {
    static Icon = "remote";
    static DeviceType = DeviceTypes.REMOTE;
    static PickerTitle = Locale.gettext("Remote");
}
